import React from 'react';
import './Login.scss';
import {  validateErrorPassword,loginUser, validateErrorEmail, 
    closeLoginForm, clearErrorMessages, openRegistrationForm, openRecoveryForm, clearUserMessages } from '../authSlice';

import  {validatePassword, validateEmail }  from '../../../helper/validation';

export default class Login extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           // userInputMail:'sandvich2008@rambler.ru',
           // userInputPassword:'121212',
            userInputMail:'',
            userInputPassword:'',
            errorValidation:'',
        }
        this.handleUserInputMail = this.handleUserInputMail.bind(this);
        this.handleUserInputPassword = this.handleUserInputPassword.bind(this);
        this.onSend = this.onSend.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCreate = this.onCreate.bind(this);
        this.onRecovery = this.onRecovery.bind(this);

    }
    //CLICK CONTINUE
onSend() {
    const {dispatch} = this.props;
    const item = {
       email: this.state.userInputMail,
       password: this.state.userInputPassword,
       
      //  email: "wscad@yandex",
       // password: "121212"
    }
    console.log("press send");
    dispatch(loginUser(item));

}
//CLOSE FORM
onClose() {
 const {dispatch} = this.props;
 dispatch(closeLoginForm());
 dispatch(clearUserMessages());
}
onCreate() {
    const {dispatch} = this.props;
    dispatch(closeLoginForm());
    dispatch(openRegistrationForm());
   }

   // OPEN RECOVERY FORM
onRecovery() {
    const {dispatch} = this.props;
    dispatch(closeLoginForm());
    dispatch(openRecoveryForm());
   }
   
  // HANDLE EMAIL 
handleUserInputMail(e) {
    const {dispatch} = this.props;
    const message = validateEmail(e.target.value);
    dispatch(validateErrorEmail(message));
    dispatch(clearErrorMessages());
    
    this.setState({
        userInputMail: e.target.value
    })
}
handleUserInputPassword(e) {
    const {dispatch} = this.props;
    const message = validatePassword(e.target.value);
    dispatch(validateErrorPassword(message));
    dispatch(clearErrorMessages());

    this.setState({
        userInputPassword: e.target.value,
        errorValidation: message
    })
}        
render() {
    let style;
        
    if ( !this.props.userData.errorMessageEmail 
        && !this.props.userData.errorMessagePassword
        && this.state.userInputMail && this.state.userInputPassword) {
      
            style = ''
        } else {
            style = 'disabled'
        }
        return (
            <div className="Login">
              <h3>Вход</h3>
               <div className='inputBlock'>
                
                    <input id="email" type="email" placeholder="Электронная почта" required 
                        value={this.state.userInputMail} onChange={this.handleUserInputMail} />
                   
                    <input type='password' id="password" placeholder="Пароль" required minLength ="5" 
                        value={this.state.userInputPassword} onChange={this.handleUserInputPassword}/>
              
               </div>

                <div className='errorBlock'>
                    <p className='error'>{this.props.userData.errorMessageEmail}</p>
                    <p className='error'>{this.props.userData.errorMessage}</p>
                    <p className='message'>{this.props.userData.userMessage}</p>
                    <p className='error'>{this.props.userData.errorMessagePassword}</p>
                </div>

                <div className='buttonBlock'>
                        <button className='loginButton' onClick={this.onSend} disabled={style}>Вход</button>
                        <button className='loginButton'onClick={this.onRecovery}>Забыли пароль?</button>
                        <span>или</span>
                        <button className='loginButton' onClick={this.onCreate}>Создать аккаунт</button>
                        <button className='loginButton' onClick={this.onClose}>Отмена</button>
                </div>

            </div>
        )
    }
}
